import { parse } from "date-fns";

import { ITransaction, ITransactionAttachment } from "interfaces/entities/transaction";

export default abstract class TransactionSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(transaction: { [key: string]: any }): ITransaction {
    return {
      id: transaction.ID,
      createdAt: parse(transaction.createdAt),
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      attachments: transaction.attachments.map((attachment: any) =>
        TransactionSerializer.deserializeAttachment(attachment)
      ),
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserializeAttachment(attachment: { [key: string]: any }, source?: "agent"): ITransactionAttachment {
    return {
      id: attachment.ID,
      cid: attachment.cid,
      type: attachment.type,
      url: attachment.url,
      name: attachment.name,
      size: attachment.size,
      source,
    };
  }
}
